import { useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { map, omit } from "ramda";
import { useEffect, useState } from "react";

const basePath = "https://hm.dev.krzysztofsikorski.pl";
const FRONT_PATH = "front.n.histmag.org";
export const fetchDB = async (
  path,
  method = "GET",
  data = {},
  responseType = "json",
) => {
  const userData = localStorage.getItem("histmag_user_jwt"); // TODO
  const token = userData ? JSON.parse(userData).token : false;
  if (!token) return {};
  // const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoic3RhbmRhcmQifQ.aMGhNkNdevDsDz4cng5Yv1n_hf336IGpLAsj6VXoG5U'

  const authObject = token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};

  const response = await fetch(`${basePath}/${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...authObject,
      Prefer: "return=representation, resolution=merge-duplicates",
    },
    ...(Object.keys(data).length
      ? {
          body: JSON.stringify(data),
        }
      : {}),
  });

  if (responseType === "json") {
    const result = await response.json();
    return result;
  }

  if (responseType === "text") {
    const result = await response.text();
    return result;
  }
};

export const useQuery = ({ query, variables, pause }) => {
  const [data, setData] = useState(false);
  const [stateVariables, setStateVariables] = useState(variables);

  const loadData = async () => {
    if (pause) return;

    const queryKeys = Object.keys(query);
    let result = {};

    for (const queryKey of queryKeys) {
      const [queryContent, isArrayable] = query[queryKey];
      const replacedQuery = queryContent.replace(
        /\$[a-z_]+/g,
        (varName) => stateVariables[varName.slice(1)],
      );
      const data = await fetchDB(replacedQuery);
      result[queryKey] = isArrayable ? data : data[0];
    }
    console.log(result);

    setData(result);
  };
  useEffect(() => {
    loadData();
  }, [stateVariables]);

  useEffect(() => {
    if (JSON.stringify(variables) !== JSON.stringify(stateVariables))
      setStateVariables(variables);
  }, [variables]);

  return [
    {
      data: pause ? true : data,
      error: false,
    },
    loadData,
  ];
};

export const useMutation = (query) => {
  const [queryContent, method] = query;

  const callMutation = async (variables) => {
    const data = variables.data;
    const rest = omit(["data"], variables);
    const replacedQuery = queryContent.replace(
      /\$[a-z]+/g,
      (varName) => rest[varName.slice(1)],
    );
    const response = await fetchDB(replacedQuery, method, data);
    return response;
  };
  return [null, callMutation];
};

export const useGQLForm = ({
  CreateQuery,
  UpdateQuery,
  DataQuery,
  parseData,
  createKey,
  path,
  afterSubmit = () => {},
}) => {
  const { register, handleSubmit, setValue, getValues, control } = useForm();
  const history = useHistory();
  const { id } = useParams();
  const idExists = id !== "create";

  const [{ data, error }, reloadQuery] = useQuery({
    query: DataQuery,
    variables: { id: parseInt(id) },
    pause: !idExists,
  });
  const [res1, createMutation] = useMutation(CreateQuery);
  const [res2, updateMutation] = useMutation(UpdateQuery);

  const onSubmitParent = (forceReload) => (data) => {
    const idReplaced = window.idReplaced || id;
    const additionalData = window.additionalData || {};
    const statusDraftObject = window.idReplaced
      ? {
          status: "draft",
          published_at: dayjs().toISOString(),
          first_publish: dayjs().toISOString(),
          priority: 0,
          speciallist: "",
          social_title: "",
          ...additionalData,
        }
      : {};

    const parsedData = parseData({
      ...data,
      ...statusDraftObject,
    });
    console.log(parsedData);

    if (
      dayjs().subtract(1, "hour").isAfter(parsedData.published_at) &&
      parsedData.status === "published"
    ) {
      if (
        !window.confirm(
          "Czy na pewno chcesz opublikować tekst z datą wsteczną?",
        )
      )
        return;
    }

    if (
      dayjs().add(7, "day").isBefore(parsedData.published_at) &&
      parsedData.status === "published"
    ) {
      if (
        !window.confirm(
          "Czy na pewno chcesz opublikować tekst z datą przyszłą dalszą niż tydzień?",
        )
      )
        return;
    }

    if (idExists) {
      afterSubmit(forceReload);
      updateMutation({
        data: parsedData,
        id: parseInt(idReplaced),
      });
      setTimeout(() => {
        fetch(
          `https://${FRONT_PATH}/api/revalidate?secret=asdnjksdnfuiaoenwu&path=/${data.slug}-${id}`,
        );
      }, 1500);
    } else {
      createMutation({
        data: parsedData,
      }).then((result) => {
        console.log(result);
        if (result.error) {
          console.error("Oh no!", result.error);
        } else {
          history.push(`/${path}/${result[0].id}`);
        }
      });
    }

    setTimeout(() => {
      reloadQuery();
    }, 2000);
  };

  const onSubmit = onSubmitParent(false);
  const onSubmitFullReload = onSubmitParent(true);

  return {
    register,
    handleSubmit,
    onSubmit,
    onSubmitFullReload,
    error,
    data,
    idExists,
    setValue,
    getValues,
    id,
    control,
  };
};
